export enum StorageKeyEnum {
    rememberMeUser = "­é\x9E\x99·«1å,z"
}